<div class="headline-with-icon">
  <div class="icon"><img alt="{{icon}}" height="40" ngSrc="assets/images/icon-{{icon}}.svg" width="40"></div>
  <headline-text [headline]="headline" [text]="text"></headline-text>
</div>

